// NOTE: the API supports comma separated values (e.g. 'eu-central-1,eu-west-1')
const regionTypes = {
    ANY: '',
    APAC: 'ap-northeast-1',
    EMEA: 'eu-central-1',
    NORTH_AMERICA: 'us-east-1',
};

export default regionTypes;
